export class PinnedAccountInformationDto {
    homeAccountId: string;
    authority: string;
    tenant: string;
}